<app-redefinicao-senha-dialog [visivel]="redefinicaoDialog" (fechar)="escondeRedefinicaoDialog()">

</app-redefinicao-senha-dialog>

<div class="body">

  <div class="login-container shadow-1">
    <div class="login-illustration">
      <div class="illustration-content">
        <h2>Integração Inteligente</h2>
        <p>Conecte seus sistemas com segurança e eficiência através da nossa plataforma de integração avançada.</p>

        <svg width="380" height="220" viewBox="0 0 380 220" xmlns="http://www.w3.org/2000/svg">
          <circle cx="190" cy="110" r="100" fill="rgba(255,255,255,0.3)"/>
          <circle cx="190" cy="110" r="70" fill="rgba(255,255,255,0.4)"/>

          <rect x="40" y="70" width="60" height="80" rx="12" fill="white" stroke="#E6EEF8" stroke-width="2"/>
          <rect x="50" y="80" width="40" height="5" rx="2" fill="#D4B2D8"/>
          <rect x="50" y="90" width="40" height="5" rx="2" fill="#D4B2D8"/>
          <rect x="50" y="100" width="30" height="5" rx="2" fill="#D4B2D8"/>
          <rect x="50" y="110" width="35" height="5" rx="2" fill="#D4B2D8"/>
          <rect x="50" y="120" width="25" height="5" rx="2" fill="#D4B2D8"/>

          <rect x="280" y="70" width="60" height="80" rx="12" fill="white" stroke="#E6EEF8" stroke-width="2"/>
          <rect x="290" y="80" width="40" height="5" rx="2" fill="#A7C5EB"/>
          <rect x="290" y="90" width="40" height="5" rx="2" fill="#A7C5EB"/>
          <rect x="290" y="100" width="30" height="5" rx="2" fill="#A7C5EB"/>
          <rect x="290" y="110" width="35" height="5" rx="2" fill="#A7C5EB"/>
          <rect x="290" y="120" width="25" height="5" rx="2" fill="#A7C5EB"/>

          <circle cx="190" cy="110" r="25" fill="#FFBCBC"/>
          <circle cx="190" cy="110" r="20" fill="#FFD6D6"/>-->
          <circle cx="190" cy="110" r="15" fill="white"/>

          <line x1="105" y1="110" x2="165" y2="110" stroke="#DCDCDC" stroke-width="3" stroke-dasharray="5,5"/>
          <line x1="215" y1="110" x2="275" y2="110" stroke="#DCDCDC" stroke-width="3" stroke-dasharray="5,5"/>

          <circle cx="110" cy="110" r="5" fill="#FFE6AA"/>
          <circle cx="250" cy="110" r="5" fill="#A7C5EB"/>

        </svg>
      </div>
    </div>

    <div class="login-form surface-card shadow-2 w-full lg:w-6">
      <div class="text-center">
<!--        <img src="assets/imagens/lxtech-logo.png" alt="Image" height="100">-->
        <div class="flex flex-wrap flex-column gap-0">
          <div><span class="text-orange-500 font-bold text-5xl">LX</span><span class="font-bold text-5xl">View</span></div>
        </div>
      </div>

      <h3>Bem-vindo de volta!</h3>
      <p class="subtitle">Acesse sua conta para gerenciar suas integrações</p>

      <form [formGroup]="loginForm">
        <div class="form-group">
          <label for="email" class="block text-900 font-medium mb-2">E-mail</label>
          <div class="input-with-icon">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-envelope" />
            <input id="email" type="text" placeholder="Digite seu e-mail" pInputText class="w-full mb-3"
                   formControlName="email">
            </p-iconField>
          </div>
        </div>

        <div class="form-group">
          <label for="password" class="block text-900 font-medium mb-2">Senha</label>
          <div class="input-with-icon">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-lock" />
            <input id="password" type="password" placeholder="Senha" pInputText class="w-full mb-3"
                   formControlName="password">
            </p-iconField>
          </div>
        </div>

        <div class="remember-forgot">
          <div class="remember">

          </div>
          <a class="font-medium no-underline text-blue-500 text-right cursor-pointer"
             (click)="abreRedefinicaoDialog()">Esqueceu sua senha?</a>
        </div>

        <button pButton pRipple label="Entrar" icon="pi pi-sign-in" class="w-full mt-3" (click)="submit()"  [loading]="loadingLogin"></button>

        <div class="security-badge pt-4">
          <i class="pi pi-shield"></i> Conexão segura com criptografia SSL
        </div>

        <div class="security-badge pt-4">
          <span>{{ getAno() }} <span class="text-orange-500 font-bold text-1xl">LXTech</span></span>
        </div>
      </form>
    </div>
  </div>

</div>
